var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#B7B8BA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m1 13 6-6-6-6"
})));
export { SvgArrowRight as ReactComponent };
export default __webpack_public_path__ + "f8dc0db4b46168c6727a1b6cef0639c4.svg";